import Swiper from "swiper";
import {A11y, Autoplay, Keyboard} from "swiper/modules";

new Swiper('.related-news-swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    watchSlidesProgress: true,
    modules: [Keyboard, A11y, Autoplay],
    autoplay: {
        delay: 4000,
        disableOnInteraction: true
    },
    keyboard: {
        enabled: true,
        pageUpDown: false
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    }
});

